module.exports = __webpack_public_path__ + "img/icone-question.164ff3da.png";